import React from "react";
import { Comment, Grid, Rating } from "semantic-ui-react";
import styles from "./CommentItem.module.scss";

interface CommentAuthor {
  name: string;
  avatar: string;
}

type Props = {
  review: {
    name: string;
    rating: number;
    comment: string;
    user: CommentAuthor;
    date: Date;
  };
};

const CommentItem: React.FC<Props> = ({
  review: { name, rating, comment, user, date },
}) => {
  return (
    <Grid>
      <Comment>
        <div className={styles.comment}>
          {/* <Comment.Avatar src={user.avatar} /> */}
          <Comment.Content>
            <div className={styles.name}>
              <Comment.Author as="a">{name}</Comment.Author>
              <Comment.Metadata>{new Date(date).toLocaleDateString()}</Comment.Metadata>
              <Rating
                icon="star"
                defaultRating={rating}
                maxRating={5}
                disabled
                className={styles.rating}
              />
            </div>
            <div className={styles.inscription}>
              <Comment.Text>{comment}</Comment.Text>
            </div>
          </Comment.Content>
        </div>
      </Comment>
    </Grid>
  );
};

export default CommentItem;
